var horizontalElevators = [];
jQuery(document).ready(function(){
    jQuery('.wp-block-vif-horizontal-elevator').each(function(){
        horizontalElevators.push(new HorizontalElevator(jQuery(this)));
    })
    jQuery(window).resize(function(){setTimeout(function(){
        horizontalElevators.forEach((elevator)=>elevator.moveToNextChild(elevator));
    }, 150)});
})

class HorizontalElevator{
    constructor(dom){
        this.dom = dom;
        this.container = dom.find('>.wp-block-vif-horizontal-elevator-container');
        this.grabber = dom.find('>.wp-block-vif-horizontal-elevator-grabber');
        this.grab = false;
        this.move = false;
        this.xRoot = 0;
        this.xTranslate = 0;
        this.xMove = 0;
        this.startHorizontalElevator(this);
    }
    translateElevator(instance, newPos=0){
        if(!newPos) newPos=instance.xTranslate;
        instance.container.css('transform', 'translateX('+newPos+'px)');
    }
    grabElevator(instance, event){
        instance.grab = true;
        instance.xRoot = event.pageX ?? event.originalEvent.touches[0].screenX;
        instance.xMove = event.pageX ?? event.originalEvent.touches[0].screenX;
        instance.dom.addClass('grab');
    }
    moveToNextChild(instance){
        let closest = instance.container.find('>.wp-block-vif-horizontal-elevator-child').first();
        let closestPos = closest.offset().left - instance.dom.offset().left;
        if(closestPos<0) closestPos = closestPos  * -1;
        instance.container.find('>.wp-block-vif-horizontal-elevator-child').each(function(){
            let currentChild = jQuery(this);
            let domLeft = instance.dom.offset().left;
            let childLeft = currentChild.offset().left;
            let trueLeft = childLeft-domLeft;
            if(trueLeft<0) trueLeft = trueLeft*-1;
            if(trueLeft<closestPos){
                closest = currentChild;
                closestPos = trueLeft;
            }
        })
        closestPos = closest.offset().left - instance.dom.offset().left - 7;
        instance.xTranslate = instance.xTranslate-closestPos;
        if(closest.is(instance.container.find('>.wp-block-vif-horizontal-elevator-child').last())) instance.xTranslate = instance.xTranslate+7;
        instance.translateElevator(instance);
    }
    getMaxLeftOffset(instance){
        let maxLeft = 0;
        let lastChild = instance.container.find('>.wp-block-vif-horizontal-elevator-child').first();
        maxLeft = instance.container[0].scrollWidth-lastChild.outerWidth();
        return -maxLeft;
    }
    ungrabElevator(instance, event){
        instance.grab = false;
        instance.dom.removeClass('grab');
        instance.xRoot = 0;
        let newPos = instance.xMove+instance.xTranslate;
        if(newPos>0) newPos = 0;
        if(newPos<instance.getMaxLeftOffset(instance)) newPos = instance.getMaxLeftOffset(instance);
        instance.xMove = 0;
        instance.xTranslate = newPos
        setTimeout(function(){instance.moveToNextChild(instance);}, 50);
    }
    moveElevator(instance, event){
        instance.move = true;
        instance.dom.addClass('move');
        let currentX = event.pageX ?? event.originalEvent.touches[0].screenX;
        let currentY = event.pageY ?? event.originalEvent.touches[0].screenY;
        if(instance.grab){
            instance.xMove = currentX - instance.xRoot;
            let newPos = instance.xMove+instance.xTranslate;
            if(newPos>0) newPos = 0;
            if(newPos<instance.getMaxLeftOffset(instance)) newPos = instance.getMaxLeftOffset(instance)+10;
            instance.translateElevator(instance, newPos);
        }
        instance.grabber.css('left', currentX - instance.dom.offset().left);
        instance.grabber.css('bottom', ((currentY - instance.dom.offset().top - instance.dom.outerHeight())*-1)-69);
    }
    mouseLeave(instance, event){
        instance.dom.removeClass('move');
        instance.grabber.css('left', '');
        instance.grabber.css('bottom', '');
    }
    startHorizontalElevator(instance){
        instance.dom.on("mousedown touchstart", function(event){instance.grabElevator(instance, event)});
        instance.dom.on("mousemove", function(event){instance.moveElevator(instance, event)});
        instance.dom.on("touchmove", function(event){instance.moveElevator(instance, event)});
        instance.dom.on("mouseup touchend", function(event){instance.ungrabElevator(instance, event)});
        instance.dom.on("mouseleave", function(event){instance.mouseLeave(instance, event)});
    }
}